import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Card, CardContent, Chip, Container, Grid, Typography } from '@mui/material';
import PageBanner from '../../components/Common/PageBanner';
import SectionHeading from '../../components/Common/SectionHeading';
import { blogPosts, pageContent } from '../../data/siteData';

function BlogPage() {
  const content = pageContent.blogPage;

  return (
    <Box>
      <PageBanner {...content.banner} />
      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 10 } }}>
        <SectionHeading
          eyebrow={content.heading.eyebrow}
          title={content.heading.title}
          subtitle={content.heading.subtitle}
        />
        <Grid container spacing={3}>
          {blogPosts.map((post) => (
            <Grid item xs={12} md={6} lg={4} key={post.slug}>
              <Card elevation={0} sx={{ height: '100%' }}>
                <CardContent sx={{ p: 3 }}>
                  <Chip label={post.category} sx={{ bgcolor: '#fff6de', color: '#c9a84c', mb: 2 }} />
                  <Typography variant="h4" sx={{ mb: 1.2 }}>{post.title}</Typography>
                  <Typography sx={{ color: '#6b5a7e', fontSize: '0.92rem', mb: 1.3 }}>{post.date}</Typography>
                  <Typography sx={{ color: 'text.secondary', lineHeight: 1.75, mb: 2.5 }}>{post.excerpt}</Typography>
                  <Button component={RouterLink} to={`/blog/${post.slug}`} variant="outlined" color="secondary">
                    {content.readMoreLabel}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default BlogPage;
